import { IconButton, CircularProgress } from '@mui/material';
import { ClearOutlined } from '@mui/icons-material';
import { forwardRef, useState } from 'react';

interface Props {
  onUnsign: () => Promise<unknown>;
}

export const RemoveSignatureButton = forwardRef<HTMLButtonElement, Props>(
  ({ onUnsign }, ref) => {
    const [isUnsigning, setIsUnsigning] = useState(false);
    const doUnsign = async () => {
      setIsUnsigning(true);
      try {
        await onUnsign();
      } catch {
        setIsUnsigning(false);
      }
    };

    return (
      <IconButton edge="end" ref={ref} onClick={doUnsign} size="large">
        {isUnsigning ? <CircularProgress size={20} /> : <ClearOutlined />}
      </IconButton>
    );
  },
);

RemoveSignatureButton.displayName = 'RemoveSignatureButton';
